import { instance } from "api/apiBase";
import { User } from "views/settings-users/types";

export const assigneeApi = {
  getAssignees: async (params?: {
    search?: string;
    property_id?: number;
  }): Promise<User[]> => {
    const { data } = await instance.get<User[]>(
      `/portal/v1/boom_crm/assignees`,
      { params }
    );
    return data;
  }
};
